<div class="min-h-screen bg-[color:var(--background)] flex items-start justify-center pt-16 sm:pt-24 pb-16 px-4 sm:px-6 lg:px-8 text-[color:var(--foreground)]">
    <div class="max-w-lg w-full space-y-8">
        <!-- Header -->
        <div class="text-center space-y-3">
            <h2 class="text-2xl sm:text-3xl font-bold text-[color:var(--foreground)]">Great choice!</h2>
            <h2 class="text-2xl sm:text-3xl font-bold text-[color:var(--foreground)]">Let's get you started</h2>
            <p class="text-sm text-[color:var(--muted-foreground)] max-w-sm mx-auto">
                Tell us a few details to set up your account and personalize your experience.
            </p>
        </div>

        <!-- Question -->
        <div class="space-y-1">
            <h3 class="text-lg font-semibold text-[color:var(--foreground)]">Which best describes you?</h3>
            <p class="text-sm text-[color:var(--muted-foreground)]">Your selection helps us tailor nibni for you.</p>
        </div>

        <!-- Cards -->
        <div class="space-y-4">
            <!-- Investor -->
            <button
                type="button"
                (click)="goToAccount('investor')"
                class="w-full text-left rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-5 shadow-sm transition hover:border-[color:var(--primary)] hover:shadow-md group"
            >
                <div class="flex items-start gap-4">
                    <div class="flex-shrink-0">
                        <div class="w-12 h-12 rounded-full bg-[#3A4E49] flex items-center justify-center">
                            <lucide-icon name="trending-up" class="h-6 w-6 text-white"></lucide-icon>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0">
                        <h4 class="text-lg font-semibold text-[color:var(--foreground)]">I'm an Investor</h4>
                        <p class="text-sm text-[color:var(--muted-foreground)] mt-0.5">I want to invest in properties and manage my portfolio.</p>
                        <ul class="mt-3 space-y-1.5 text-sm text-[color:var(--muted-foreground)]">
                            <li class="flex items-center gap-2">
                                <span class="flex-shrink-0 w-4 h-4 rounded-full bg-[#3A4E49]/10 flex items-center justify-center">
                                    <lucide-icon name="check" class="h-2.5 w-2.5 text-[#3A4E49]"></lucide-icon>
                                </span>
                                Discover exclusive projects
                            </li>
                            <li class="flex items-center gap-2">
                                <span class="flex-shrink-0 w-4 h-4 rounded-full bg-[#3A4E49]/10 flex items-center justify-center">
                                    <lucide-icon name="check" class="h-2.5 w-2.5 text-[#3A4E49]"></lucide-icon>
                                </span>
                                Reserve units and invest securely
                            </li>
                            <li class="flex items-center gap-2">
                                <span class="flex-shrink-0 w-4 h-4 rounded-full bg-[#3A4E49]/10 flex items-center justify-center">
                                    <lucide-icon name="check" class="h-2.5 w-2.5 text-[#3A4E49]"></lucide-icon>
                                </span>
                                Track and grow your portfolio
                            </li>
                        </ul>
                    </div>
                    <div class="flex-shrink-0 self-center hidden sm:block">
                        <img
                            src="https://assetsnibni.zohostratus.com/images/icons/building-blue.avif"
                            alt="Properties"
                            class="h-16 w-auto object-contain opacity-80"
                            onerror="this.style.display='none'"
                        />
                    </div>
                    <div class="flex-shrink-0 self-center">
                        <lucide-icon name="chevron-right" class="h-5 w-5 text-[color:var(--muted-foreground)] group-hover:text-[color:var(--primary)] transition"></lucide-icon>
                    </div>
                </div>
            </button>

            <!-- Partner -->
            <button
                type="button"
                (click)="goToAccount('partner')"
                class="w-full text-left rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-5 shadow-sm transition hover:border-[color:var(--primary)] hover:shadow-md group"
            >
                <div class="flex items-start gap-4">
                    <div class="flex-shrink-0">
                        <div class="w-12 h-12 rounded-full bg-[#AA9072] flex items-center justify-center">
                            <lucide-icon name="users" class="h-6 w-6 text-white"></lucide-icon>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0">
                        <h4 class="text-lg font-semibold text-[color:var(--foreground)]">I'm a Partner</h4>
                        <p class="text-sm text-[color:var(--muted-foreground)] mt-0.5">I manage projects, inventory, leads and sales teams.</p>
                        <ul class="mt-3 space-y-1.5 text-sm text-[color:var(--muted-foreground)]">
                            <li class="flex items-center gap-2">
                                <span class="flex-shrink-0 w-4 h-4 rounded-full bg-[#AA9072]/10 flex items-center justify-center">
                                    <lucide-icon name="check" class="h-2.5 w-2.5 text-[#AA9072]"></lucide-icon>
                                </span>
                                Manage inventory and availability
                            </li>
                            <li class="flex items-center gap-2">
                                <span class="flex-shrink-0 w-4 h-4 rounded-full bg-[#AA9072]/10 flex items-center justify-center">
                                    <lucide-icon name="check" class="h-2.5 w-2.5 text-[#AA9072]"></lucide-icon>
                                </span>
                                Track leads and customer interactions
                            </li>
                            <li class="flex items-center gap-2">
                                <span class="flex-shrink-0 w-4 h-4 rounded-full bg-[#AA9072]/10 flex items-center justify-center">
                                    <lucide-icon name="check" class="h-2.5 w-2.5 text-[#AA9072]"></lucide-icon>
                                </span>
                                Empower your team
                            </li>
                        </ul>
                    </div>
                    <div class="flex-shrink-0 self-center hidden sm:block">
                        <img
                            src="https://assetsnibni.zohostratus.com/images/icons/building-brown.avif"
                            alt="Partner"
                            class="h-16 w-auto object-contain opacity-80"
                            onerror="this.style.display='none'"
                        />
                    </div>
                    <div class="flex-shrink-0 self-center">
                        <lucide-icon name="chevron-right" class="h-5 w-5 text-[color:var(--muted-foreground)] group-hover:text-[color:var(--primary)] transition"></lucide-icon>
                    </div>
                </div>
            </button>

            <!-- Not Sure -->
            <a
                href="mailto:support@nibni.com"
                class="block w-full text-left rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-5 shadow-sm transition hover:border-[color:var(--primary)] hover:shadow-md group"
            >
                <div class="flex items-start gap-4">
                    <div class="flex-shrink-0">
                        <div class="w-12 h-12 rounded-full bg-[color:var(--muted)] flex items-center justify-center">
                            <lucide-icon name="help-circle" class="h-6 w-6 text-[color:var(--muted-foreground)]"></lucide-icon>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0">
                        <h4 class="text-lg font-semibold text-[color:var(--foreground)]">I'm Not Sure</h4>
                        <p class="text-sm text-[color:var(--muted-foreground)] mt-0.5">Book a quick walkthrough with our team and we'll guide you.</p>
                    </div>
                    <div class="flex-shrink-0 self-center">
                        <lucide-icon name="chevron-right" class="h-5 w-5 text-[color:var(--muted-foreground)] group-hover:text-[color:var(--primary)] transition"></lucide-icon>
                    </div>
                </div>
            </a>
        </div>

        <!-- Footer -->
        <div class="text-center pt-4">
            <p class="text-[color:var(--muted-foreground)] text-sm">
                Already have an account?
                <a routerLink="/login" class="text-[color:var(--primary)] hover:text-[color:var(--primary-hover)] font-semibold ml-1">Sign In</a>
            </p>
        </div>
    </div>
</div>
